import { isMobile } from "app/assets/javascripts/utils/breakpoints"
import { adStatuses, currentRefreshInterval } from "./status"
import { googletag } from "./shared"
import { ADS_BY_SIZE } from "./sizes"
import { isPlayerInFullscreen } from "../../new_player/player-fullscreen-util"

const queueRefresh = (slot, path) => {
  console.log(`Queuing refresh for ${path} of ${currentRefreshInterval}s`)

  setTimeout(function () {
    if (isPlayerInFullscreen()) {
      console.log(`Player in fullscreen, skipping refresh for ${path}`)
      queueRefresh(slot, path)
    } else {
      console.log(`Refreshing ${path}`)
      googletag.pubads().refresh([slot])
    }
  }, currentRefreshInterval * 1000)
}

export const displayAd = (group, key) => {
  const ad = ADS_BY_SIZE[group][key]
  const { id, shouldRefresh } = ad
  const status = adStatuses[group][key]
  if (status && status.initialized && !status.filled) {
    googletag.cmd.push(function () {
      if (!document.getElementById(id)) {
        return
      }

      googletag.display(id)
      status.filled = true

      googletag.pubads().addEventListener("impressionViewable", function (event) {
        const slot = event.slot

        if (!shouldRefresh || currentRefreshInterval === 0) {
          return
        }

        if (slot.getTargeting(id).indexOf("true") > -1) {
          queueRefresh(slot, status.activePath)
        }
      })
    })
  }
}

const displayAdGroup = (group) => {
  Object.keys(ADS_BY_SIZE[group]).forEach((key) => {
    displayAd(group, key)
  })
}

export const displayAds = () => {
  if (isMobile()) {
    displayAdGroup("mobile")
  } else {
    displayAdGroup("desktop")
  }

  displayAdGroup("responsive")
}

displayAds()
